<template>
  <div class="content">
    <div class="tips">加载中...</div>
  </div>
</template>

<script>
import util from "../../utils/utils";
import * as api from "./qywxApi";
import * as qywxConst from "./const";
import Cookies from "js-cookie";
export default {
  data() {
    return {};
  },
  created() {
    if (this.$route.query.appInfo) {
      // 授权回调
      let appInfo = JSON.parse(this.$route.query.appInfo);
      console.log(111, "appInfo", appInfo);
      if (
        appInfo.openUserId &&
        appInfo.salesCenter &&
        appInfo.salesCenter.length > 0 &&
        appInfo.salesCenter[0].appId
      ) {
        // 获取用户信息
        let postObj = {
          account: appInfo.openUserId,
          appid: appInfo.salesCenter[0].appId,
          accountType: "qywx",
        };
        api.getUserByAccount(postObj).then((res) => {
          console.log(111, "getUserByAccount", res);
          if (res.code === 0) {
            let gzhAppid = appInfo.salesCenter[0].appId;
            let gzhSubDomain = appInfo.salesCenter[0].domain;
            let url = appInfo.salesCenter[0].saleCenterUrl;
            if (res.data && res.data.openid && res.data.passport) {
              // 有用户信息 带上openid和passport 跳转到返回的售楼中心链接
              // Cookies.set("openid", res.data.openid, { expires: 30 });
              // Cookies.set("passport", res.data.passport, { expires: 30 });
              url = util.addUrlParamFromObj(url, {
                openid: res.data.openid,
                passport: res.data.passport,
              });
              if (this.global.isLoc) {
                console.log(111, "绑定过的用户,因在本地不做跳转", url);
              } else {
                location.href = url;
              }
            } else {
              // 没有用户信息 去微信绑定
              url = util.addUrlParamFromObj(url, {
                account: appInfo.openUserId,
                accountType: "qywx",
              });
              url = `${
                api.yqwxRsApiProtocol
              }//${gzhSubDomain}.ttrushi.com/qc-webapp/wxapi.do?appid=${gzhAppid}&scope=snsapi_userinfo&wxauthcburl=${encodeURIComponent(
                url
              )}`;
              console.log(111, "去微信打开链接", url);
              // util.messageBox(url);
              // return;
              if (this.global.isLoc) {
                console.log(111, "拿到去微信的绑定链接，因在本地不做跳转");
              } else {
                location.href = url;
              }
            }
          }
        });
      }
    } else {
      let postObj = {
        scope: "snsapi_userinfo",
        corpId: qywxConst.corpId,
        suiteId: qywxConst.suiteId,
        h5CallBackUrl: encodeURIComponent(location.href),
      };
      api.getAuthUrl(postObj).then((res) => {
        console.log(111, "getAuthUrl", res);
        if (res.responseCode == 200) {
          if (this.global.isLoc) {
            console.log(111, "拿到授权链接，因在本地不做跳转");
          } else {
            location.href = res.result;
          }
        }
      });
    }
  },
};
</script>

<style>
.tips {
  text-align: center;
  margin-top: 200px;
}
</style>